package com.tfc.care.tfccare.utils

/**
 * A simple logger utility for the application.
 */
object Logger {
    private var isDebug: Boolean = false

    /**
     * Initializes the logger.
     * @param debug Set to true to enable debug logs, false to disable them.
     */
    fun init(debug: Boolean) {
        isDebug = debug
    }

    /**
     * Logs a message to the console if debug mode is enabled.
     * @param message The message to log.
     */
    fun d(message: String) {
        if (isDebug) {
            println("[DEBUG] $message")
        }
    }

    /**
     * Logs an error message to the console.
     * @param message The error message.
     * @param throwable Optional throwable to log.
     */
    fun e(message: String, throwable: Throwable? = null) {
        // We always log errors, but we can format them differently in production
        println("[ERROR] $message")
        throwable?.printStackTrace()
    }
}
